import { Proposal } from '@trnsact/trnsact-shared-types';
import { createTableColumns } from './tableConfig';
import { Table } from 'components/shared/Table';
import { generateProposalPageURL } from 'utils/generateProposalPageURL';

interface Props {
  tableData?: Proposal[];
  routePath: string;
  loading?: boolean;
}

export const ProposalsTable = ({ tableData, routePath, loading }: Props) => {
  const getProposalLink = (proposal: Proposal) => {
    if (!proposal.id || !proposal.account?.dynamicsAccountId) return;

    const url = generateProposalPageURL(proposal.id, proposal.account?.dynamicsAccountId);

    window.open(url, '_blank');
  };

  const handleGoToProposal = (proposal: Proposal) => {
    window.open(`/proposalDetail/${proposal.id}?from=/${routePath}`, '_blank');
  };

  const columns = createTableColumns({
    tableData,
    onGoToProposal: handleGoToProposal,
    onGoToProposalDetail: getProposalLink,
  });

  return <Table<Proposal> tableData={tableData || []} columns={columns} loading={loading} />;
};
